<template>
  <div class="toolbar flex align-center justify-space-between">
    <div class="box-left box grow flex">
      <button
        @click="toggleSidebar"
        v-if="menuBurger !== 'right'"
        class="toggle-sidebar card-base card-shadow--small"
      >
        <i class="mdi mdi-menu"></i>
      </button>

      <img class="logo-mini" :src="renderMiniLogo" alt="logo" />

      <search class="hidden-xs-only"></search>
    </div>
    <div>
      <button class="btn" @click="callSupport" size="mini">
        <img src="https://img.icons8.com/ios/16/000000/service.png" />
        <span> Solicitudes </span>
      </button>
    </div>
    <div class="box-right flex align-center pl-10">
      <el-dropdown trigger="click" @command="onCommandLang">
        <span class="el-dropdown-link">
          <i
            class="flag-icon"
            :class="{ ['flag-icon-' + (lang === 'en' ? 'us' : lang)]: true }"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="en" v-if="$i18n.locale !== 'en'"
            ><i class="flag-icon flag-icon-us mr-15"></i
            >English</el-dropdown-item
          >
          <el-dropdown-item command="es" v-if="$i18n.locale !== 'es'"
            ><i class="flag-icon flag-icon-es mr-15"></i
            >Spanish</el-dropdown-item
          >
          <el-dropdown-item command="fr" v-if="$i18n.locale !== 'fr'"
            ><i class="flag-icon flag-icon-fr mr-15"></i
            >French</el-dropdown-item
          >
          <el-dropdown-item command="pt" v-if="$i18n.locale !== 'pt'"
            ><i class="flag-icon flag-icon-pt mr-15"></i
            >Portuguese</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <button class="fullscreen-button" @click="toggleFullscreen">
        <i class="mdi mdi-fullscreen" v-if="!fullscreen"></i>
        <i class="mdi mdi-fullscreen-exit" v-if="fullscreen"></i>
      </button>

      <el-popover
        ref="popover"
        placement="bottom"
        :width="popoverWidth"
        trigger="click"
      >
        <NotificationBox
          v-on:DisplayNotificationDot="setNotificationDot"
        ></NotificationBox>
      </el-popover>
      <el-badge
        v-show="notificationDotNumber > 0"
        :value="notificationDotNumber"
        :is-dot="notificationDotNumber < 1"
        class="notification-icon-badge"
      >
        <el-button
          v-popover:popover
          icon="mdi mdi-bell"
          class="notification-icon"
          v-bind:class="{ 'notification-animation': notificationDotNumber > 0 }"
        ></el-button>
      </el-badge>

      <el-dropdown
        trigger="click"
        @command="onCommandCompany"
        title="Empresas"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario, roles.ChangeCompany])"
      >
        <button class="el-dropdown-link change-currentCompany-icon">
          <i class="mdi mdi-domain mr-10"></i>
        </button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="VF" v-if="currentCompany !== 'VF'"
            >Ventafiel Technologies</el-dropdown-item
          >
          <el-dropdown-item command="TB" v-if="currentCompany !== 'TB'"
            >Tennos Business</el-dropdown-item
          >
          <el-dropdown-item command="RB" v-if="currentCompany !== 'RB'"
            >Rabbey</el-dropdown-item
          >
          <el-dropdown-item command="MTR" v-if="currentCompany !== 'MTR'"
            >Magytrack</el-dropdown-item
          >
          <el-dropdown-item command="MGPSLA" v-if="currentCompany !== 'MGPSLA'"
            >Magycorp SRL</el-dropdown-item
          >
          <el-dropdown-item command="MGPTSA" v-if="currentCompany !== 'MGPTSA'"
            >Magycorp SA</el-dropdown-item
          >
          <el-dropdown-item command="MGPTT" v-if="currentCompany !== 'MGPTT'"
            >Magycorp Technologies</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <NewFormRequest ref="NewFormRequest" />

      <span class="username"
        ><router-link to="/profile">{{
          currentUser.FullName
        }}</router-link></span
      >

      <el-dropdown trigger="click" @command="onCommand">
        <span class="el-dropdown-link">
          <img
            :src="
              currentUser.ImageUrl ? currentUser.ImageUrl : renderAlterAvatar
            "
            class="avatar"
            alt="avatar"
          />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/profile"
            ><i class="mdi mdi-account mr-10"></i> Profile</el-dropdown-item
          >
          <el-dropdown-item
            command="/manager/roles"
            v-if="IsInRoles([roles.Desarrollador])"
            ><i class="mdi mdi-cog mr-10"></i> Manager</el-dropdown-item
          >
          <el-dropdown-item command="/logout" divided
            ><i class="mdi mdi-logout mr-10"></i> Logout</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

      <button
        @click="toggleSidebar"
        v-if="menuBurger === 'right'"
        class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small"
      >
        <i class="mdi mdi-menu"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import NotificationBox from "@/components/NotificationBox";
import Search from "@/components/Search";
import NewFormRequest from "@/components/requests/NewRequestForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "Toolbar",
  props: ["menuBurger"],
  data() {
    return {
      popoverWidth: 300,
      notificationDotNumber: 0,
      fullscreen: false,
      lang: "us",
      URi: "https://portal.tennosbusiness.com:9480/Account/login?empresa=TB"
      //URi: "http://localhost:51433/Account/login?empresa=TB"
    };
  },
  methods: {
    ...mapActions({ getUserInfo: "user/userInfo" }),
    ...mapMutations({ setSplashScreen: "setSplashScreen" }),
    onCommandLang(lang) {
      if (lang.charAt(0) === "/") {
        this.onCommand(lang);
      } else {
        this.lang = lang;
        this.$i18n.locale = lang;
        localStorage.setItem("locale", lang);
        this.$moment.locale(lang);
      }
    },
    onCommand(path) {
      this.$router.push(path);
    },
    onCommandCompany(currentCompany) {
      const url = `/api/users/ChangeCompany?companySelected=${currentCompany}`;
      this.$http.post(url).then(() => {
        this.getUserInfo().then(() => {
          window.location.reload();

          this.$store.commit(
            "TOGGLE_UPDATE_COMPANY",
            !this.$store.state.updateCompany
          );
        });
      });
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    resizePopoverWidth() {
      if (window.innerWidth <= 768) {
        this.popoverWidth = 250;
      } else {
        this.popoverWidth = 340;
      }
    },
    toggleFullscreen() {
      this.$fullscreen.toggle(document.querySelector("body"), {
        wrap: false,
        callback: () => {
          this.fullscreen = this.$fullscreen.getState();
        }
      });
    },
    callSupport() {
      const params = {
        CompanyID: this.currentCompany,
        Employeeid: this.currentUser.EmployeeId
      };
      this.$http
        .get("api/InternalServiceRequest/PeddingQualify", {
          params: { ...params }
        })
        .then((response) => {
          const { data } = response;
          if (data.length > 0) {
            this.$notify({
              title: "Aviso",
              message:
                "Para crear nuevas solicitudes debe validar o calificar las que están pendientes.",
              type: "warning",
              duration: 0
            });
            this.closeFormSupport();
            return;
          } else {
            this.$refs.NewFormRequest.drawer = true;
          }
        });
    },
    setNotificationDot(amountOfNotifications) {
      this.notificationDotNumber = amountOfNotifications;
    }
  },
  computed: {
    ...mapGetters("my_request", ["myRequestInClosedCount2"]),

    test() {
      return this.$moment(Date.now()).fromNow();
    },
    ...mapState({
      perfilImage: (state) => state.user.imageUrl
    }),
    renderMiniLogo() {
      return require("@/assets/images/logo.svg");
    },
    renderAlterAvatar() {
      return require("@/assets/images/logo.svg");
    }
  },
  components: {
    NotificationBox,
    Search,
    NewFormRequest
  },
  mounted() {
    this.fullscreen = this.$fullscreen.getState();
    this.resizePopoverWidth();
    window.addEventListener("resize", this.resizePopoverWidth);
    this.URi = this.URi + "&account=" + this.currentUser.UserName;
  },
  created() {
    this.lang = this.$i18n.locale;

    // Carga inicial para el store
    // TODO: por el momento aca se hace la carga inicial para asegurar que se ejecute cuando el user este auth
    this.$store.dispatch("user/fetchUsers");

    // this.$store.dispatch("my_request/fetchMyRequests");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizePopoverWidth);
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";
@import "../assets/scss/_mixins";

// codigo css para button soporte tecnico

.btn {
  background-color: #f4d03e; /* Blue background */
  border: none; /* Remove borders */
  color: rgb(47, 47, 47);
  padding: 10px 16px; /* Some padding */
  font-size: 16px; /* Set a font size */
  cursor: pointer; /* Mouse pointer on hover */
  border-radius: 12px;
  transition: all 0.3s;
  font-weight: bold;
}
.btn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.3s;
}

.btn span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -10px;
  transition: 0.3s;
}

.btn:hover span {
  padding-right: 25px;
  color: black;
  background-color: #f4d03e; /* Blue background */
}

.btn:hover span:after {
  opacity: 1;
  right: 0;
  transition: 0.3s;
}
.btn:hover {
  background-color: #f4d03e; /* Blue background */
  transition: 0.3s;
}
// fin codigo css para button soporte tecnico

.toolbar {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .username {
    margin-left: 20px;
    font-weight: bold;
    @include text-bordered-shadow();

    a {
      color: $text-color;
      text-decoration: none;

      &:hover {
        color: $text-color-accent;
      }
    }
  }

  .avatar {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    border: 1px solid #fff;
    margin-left: 20px;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
        0px 2px 7px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .change-currentCompany-icon {
    font-size: 20px;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    //color: #aab7c5;
    // color: transparentize($text-color, 0.7);
    color: $text-color;
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-accent;
    }
  }

  .notification-icon {
    font-size: 20px;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    //color: #aab7c5;
    color: transparentize($text-color, 0.7);
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-accent;
    }
  }

  .notification-animation {
    animation-name: notification;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  @keyframes notification {
    from {
      color: rgb(192, 199, 207);
    }
    to {
      color: rgb(236, 32, 95);
    }
  }

  .toggle-sidebar {
    border: 1px solid transparent;
    height: 32px;
    min-height: 32px;
    line-height: 32px;
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    box-sizing: border-box;
    text-align: center;
    margin: 0;
    outline: none;
    margin-right: 5px;
    font-size: 24px;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    color: $text-color;
    background: white;
    display: none;
    opacity: 0;
    transition: all 0.5s;

    &__right {
      margin-right: 0px;
      margin-left: 5px;
    }

    &:hover,
    &:focus,
    &:active {
      color: $text-color-accent;
      border-color: $text-color-accent;
    }
  }

  .fullscreen-button {
    font-size: 24px;
    cursor: pointer;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    //color: #aab7c5;
    color: transparentize($text-color, 0.7);
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-accent;
    }
  }

  .TISupport {
    padding: 4px;
    box-shadow: 5px 10px 18px rgb(216, 148, 0);
  }
  .logo-mini {
    width: 32px;
    height: 32px;
    display: none;
  }

  .el-dropdown {
    .flag-icon {
      box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;
      border: 1px solid lighten($background-color, 20%);
      background-color: lighten($background-color, 20%);
    }
  }
}

@media (max-width: 650px) {
  .toolbar {
    .username {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .toolbar {
    padding: 0 10px;

    .toggle-sidebar {
      display: block;
      opacity: 1;
    }

    .fullscreen-button {
      display: none;
    }

    .logo-mini {
      display: inherit;
    }
  }
}
</style>
